import api from "./client";
import { openAuthenticatedPdf } from "./pdf";

export const getInvoices = (params) => api.get("/invoices", { params });
export const getInvoice = (invoiceId) => api.get(`/invoices/${invoiceId}`);
export const createInvoice = (data) => api.post("/invoices", data);
export const lookupBookingForInvoice = (enquiryId) => api.get("/invoices/lookup-booking", { params: { enquiry_id: enquiryId } });
export const updateInvoice = (invoiceId, data) =>
  api.patch(`/invoices/${invoiceId}`, data);
export const updateInvoiceStatus = (invoiceId, status) =>
  api.patch(`/invoices/${invoiceId}/status`, null, { params: { status } });
export const voidInvoice = (invoiceId) =>
  api.post(`/invoices/${invoiceId}/void`);
export const updateInvoiceInXero = (invoiceId) =>
  api.post(`/invoices/${invoiceId}/update-in-xero`);
// Re-address ONE invoice to another legal entity. body.mode: preview | apply.
export const applyInvoiceBillingEntity = (invoiceId, body) => api.post(`/invoices/${invoiceId}/billing-entity`, body);
export const editInvoiceAndSync = (invoiceId, data) =>
  api.post(`/invoices/${invoiceId}/edit-and-sync`, data);
export const openInvoicePdf = (invoiceId) =>
  openAuthenticatedPdf(`/invoices/${invoiceId}/pdf`);
export const openPreviewInvoicePdf = (invoiceData) =>
  openAuthenticatedPdf("/invoices/preview-pdf", { method: "POST", body: invoiceData });
export const reassignInvoice = (invoiceId, newBookingId) =>
  api.post(`/invoices/${invoiceId}/reassign`, null, { params: { new_booking_id: newBookingId } });
export const unlinkInvoice = (invoiceId) =>
  api.post(`/invoices/${invoiceId}/unlink`);
export const previewPaymentReminder = (invoiceId) =>
  api.post(`/invoices/${invoiceId}/payment-reminder/preview`);
export const sendPaymentReminder = (invoiceId, data) =>
  api.post(`/invoices/${invoiceId}/payment-reminder/send`, data);
export const previewBulkPaymentReminder = (invoiceIds) =>
  api.post("/invoices/bulk-payment-reminder/preview", { invoice_ids: invoiceIds });
export const sendBulkPaymentReminder = (invoiceIds, data) =>
  api.post("/invoices/bulk-payment-reminder/send", { invoice_ids: invoiceIds, ...data });
export const pushInvoiceToXero = (invoiceId) => api.post(`/invoices/${invoiceId}/push-to-xero`);
export const bulkVoidInvoices = (invoiceIds) =>
  api.post("/invoices/bulk-void", { invoice_ids: invoiceIds });
export const bulkPushToXero = (invoiceIds) =>
  api.post("/invoices/bulk-push-to-xero", { invoice_ids: invoiceIds });
export const bulkMarkPaidPreview = (invoiceIds) =>
  api.post("/invoices/bulk-mark-paid/preview", { invoice_ids: invoiceIds });
export const bulkMarkPaid = (data) =>
  api.post("/invoices/bulk-mark-paid", data);
export const syncInvoicesFromXero = () => api.post("/invoices/sync-from-xero");
export const getFinancingInvoices = () => api.get("/invoices/financing");
export const getFinancingAnalytics = () => api.get("/invoices/financing/analytics");
export const updateInvoiceFinancing = (id, data) => api.patch(`/invoices/${id}/financing`, data);
export const getFinancingWeeklyReport = () => api.get("/invoices/financing/weekly-report");
export const getVatReserves = () => api.get("/invoices/vat-reserves");
export const getVatReservesWeekly = () => api.get("/invoices/vat-reserves/weekly");
export const searchXeroContacts = (query) =>
  api.get("/invoices/xero-contacts/search", { params: { q: query } });
export const propagateXeroContact = (data) =>
  api.post("/invoices/propagate-xero-contact", data);
export const getDeposits = () => api.get("/invoices/deposits");
